import { render } from "./MarketReportsMenu.vue?vue&type=template&id=08be1452&scoped=true"
import script from "./MarketReportsMenu.vue?vue&type=script&lang=js"
export * from "./MarketReportsMenu.vue?vue&type=script&lang=js"

import "./MarketReportsMenu.vue?vue&type=style&index=0&id=08be1452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08be1452"]])

export default __exports__